import * as yup from "yup";
import { Validations } from "../../config";

export const resetSchema = yup.object().shape({
  "new-password": Validations.password,
  "confirm-password": Validations.password,
});
